export enum ContentCardPreset {
  ANNOUNCEMENT = 'ANNOUNCEMENT',
  NEWS = 'NEWS',
  OFFER = 'OFFER',
}
